import React from 'react'
import MeetingInfo from './MeetingInfo'
import AttendeesList from './AttendeesList'
import {AutoSizer} from 'react-virtualized'
import MediaQuery from 'react-responsive'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'

const MeetingCreate = ({
  errors,
  user,
  meeting,
  dispatch,
  addMeetingAttendee,
  removeMeetingAttendee
}) => {
  const localeState = useLocaleState()
  return (
    <Container>
      <MeetingInfo
        errors={errors}
        user={user}
        meeting={meeting}
        dispatch={dispatch}
      />
      <TitleContainer>
        {_L({key: 'Invite Attendees', localeState})}
      </TitleContainer>
      <AttendeesContainer>
        <MediaQuery maxDeviceWidth={768}>
          {matches =>
            matches ? (
              <AttendeesList
                meeting={meeting}
                addMeetingAttendee={addMeetingAttendee}
                removeMeetingAttendee={removeMeetingAttendee}
              />
            ) : (
              <AutoSizer>
                {({height, width}) => (
                  <AttendeesList
                    width={width}
                    height={height}
                    meeting={meeting}
                    addMeetingAttendee={addMeetingAttendee}
                    removeMeetingAttendee={removeMeetingAttendee}
                  />
                )}
              </AutoSizer>
            )
          }
        </MediaQuery>
      </AttendeesContainer>
    </Container>
  )
}

export default MeetingCreate

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #eff0f3;
`

const TitleContainer = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #a4a9b7;
  padding: 20px 30px 0 30px;
`

const AttendeesContainer = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  background-color: #eff0f3;
`
